/**
 * Preditiva Gult Premium V2
 * Copyright (c) 2026 Preditiva. Todos os direitos reservados.
 * Tema proprietario - uso exclusivo clientes Preditiva.
 */
/**
 * constants.js — Eventos globais e constantes
 *  define eventos pub/sub usados entre Custom Elements.
 */

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  sectionRefresh: 'section-refresh',
};

// Rotas da Shopify (usadas nos Custom Elements)
// Estas são populadas pelo Liquid no theme.liquid via <script> inline
// Ex: window.routes = { cart_url: '/cart', cart_add_url: '/cart/add.js', ... }
